<template>
  <div class="grid-operations">
    <template v-for="(operation,i) in operations">
      <span v-if="getDisabled(operation) && operation.visible(params.data)" :key="i" style="padding: 5px">{{ operation.title }}</span>
      <a v-else-if="operation.visible(params.data)" :key="i" :style="operation.cssStyle" :class="`grid-operations-${operation.type}`" @click="()=>operation.onClick(params.data)">{{ operation.title }}</a>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'OperationRender',
  data() {
    return {
      operations: []
    }
  },
  created() {
    this.operations = this.params.operations
  },
  methods: {
    getDisabled(operation) {
      if (typeof operation.disabled === 'function') {
        return operation.disabled(this.params.data)
      }
      return operation.disabled
    }
  }
})
</script>

<style lang="scss">
@import "src/styles/element-variables";
.grid-operations{
  a {
    padding: 5px;
  }
  &-primary {
    color: $--color-primary;
  }
  &-success {
    color: $--color-success;
  }
  &-warning {
    color: $--color-warning;
  }
  &-danger {
    color: $--color-danger;
  }
}
</style>
